import { FC, ReactNode } from "react";

import { Stack } from "@mui/material";

interface AssistantBubbleTextProps {
  children: ReactNode;
}

export const AssistantBubbleText: FC<AssistantBubbleTextProps> = ({ children }) => (
  <Stack
    sx={(theme) => ({
      px: 1.5,
      py: 1,
      minWidth: 0,
      overflowWrap: "anywhere",
      borderRadius: theme.radius(1),
      bgcolor: theme.palette.surface.neutral.supershy,
    })}
  >
    {children}
  </Stack>
);
